// Generated by scripts/sync-version.mjs. Do not edit by hand.
export const SDK_VERSION = '1.2.0';
